(function () {
  const SELECTORS = {
    root: ".pb-box-neos-ii-series",
    modelCard: ".series-model-selector .version-link",
    colorItem: ".variant-selector .opts-1 .vs-opt-item",
    setItem: ".variant-selector .opts-2 .vs-radio-item"
  };
  function compareDeviceType() {
    return window.matchMedia("(max-width: 1024px)").matches
      ? "mobile"
      : "desktop";
  }

  function getCompareModels(dialog) {
    if (!dialog) {
      return {
        leftModel: "",
        rightModel: ""
      };
    }

    const selectors = dialog.querySelectorAll(".n2s-sel");

    return {
      leftModel:
        selectors[0]?.options[selectors[0].selectedIndex]?.text?.trim() || "",
      rightModel:
        selectors[1]?.options[selectors[1].selectedIndex]?.text?.trim() || ""
    };
  }

  function trackCompareEvent(eventName, params = {}) {
    const payload = {
      compare_name: "neos_ii_series",
      page_path: window.location.pathname,
      ...params
    };

    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, payload);
    }

    console.log("[neos-series-compare]", eventName, payload);
  }
  const isNeosII = (model) => model === "NEOS II";
  const isRemoveUltraTest = (root) => root?.dataset.elevatePageTest === "remove-ultra";
  const isAllowedModel = (root, model) => !isRemoveUltraTest(root) || model === "NEOS II SE" || model === "NEOS II";
  function getRoot() {
    return document.querySelector(SELECTORS.root);
  }

  function getQuantity() {
    const input = document.querySelector(".quantity-selector-wrapper input[name='quantity']");
    const value = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function getVariants(root) {
    const carrier = root.querySelector(".as-variants-data");
    if (!carrier) return [];
    try {
      return JSON.parse(carrier.textContent || "[]");
    } catch (error) {
      console.warn("Unable to parse NEOS II Series variants", error);
      return [];
    }
  }

  function optionValue(item, key) {
    if (!item) return "";
    return item.dataset[key] || item.getAttribute(`data-${key.replace(/([0-9])$/, "-$1")}`) || "";
  }

  function findVariant(root, model, color, set) {
    const setValue = isNeosII(model) ? set : "Standard";
    return getVariants(root).find((variant) => {
      const options = variant.options || [];
      return options[0] === model && options[1] === color && (options[2] || "Standard") === setValue;
    });
  }

  function firstColorForModel(root, model) {
    const item = Array.from(root.querySelectorAll(SELECTORS.colorItem)).find((color) => {
      return color.dataset.model === model;
    });
    return item ? item.dataset.value : "";
  }

  function firstSetForModelColor(root, model, color) {
    const item = Array.from(root.querySelectorAll(SELECTORS.setItem)).find((setItem) => {
      return setItem.dataset.model === model && optionValue(setItem, "opt1") === color;
    });
    return item ? optionValue(item, "opt2") : "Standard";
  }

  function selectedState(root) {
    const selectedRadio = root.querySelector(`${SELECTORS.setItem}.selected`);
    const selectedModel = root.querySelector(`${SELECTORS.modelCard}.selected`);
    return {
      model: root.dataset.model || (selectedModel && selectedModel.dataset.model) || "NEOS II Ultra",
      color: root.querySelector(".opts-val-1") ? root.querySelector(".opts-val-1").textContent.trim() : "",
      set: selectedRadio ? optionValue(selectedRadio, "opt2") : (root.dataset.set || "Standard")
    };
  }

  function setText(root, selector, value) {
    const element = root.querySelector(selector);
    if (element) element.textContent = value || "";
  }

  function updateModelCards(root, model) {
    root.querySelectorAll(SELECTORS.modelCard).forEach((card) => {
      card.classList.toggle("selected", card.dataset.model === model);
      card.setAttribute("aria-pressed", card.dataset.model === model ? "true" : "false");
    });
  }

  function updateColorItems(root, model, color) {
    let nextColor = color;
    const hasColor = Array.from(root.querySelectorAll(SELECTORS.colorItem)).some((item) => {
      return item.dataset.model === model && item.dataset.value === color;
    });
    if (!hasColor) nextColor = firstColorForModel(root, model);

    root.querySelectorAll(SELECTORS.colorItem).forEach((item) => {
      const visible = item.dataset.model === model;
      item.classList.toggle("d-none", !visible);
      item.classList.toggle("selected", visible && item.dataset.value === nextColor);
      item.setAttribute("aria-pressed", visible && item.dataset.value === nextColor ? "true" : "false");
    });

    setText(root, ".opts-val-1", nextColor);
    root.dataset.color = nextColor;
    return nextColor;
  }

  function updateSetItems(root, model, color, set) {
    const showSet = isNeosII(model);
    let nextSet = showSet ? set : "Standard";
    const hasSet = Array.from(root.querySelectorAll(SELECTORS.setItem)).some((item) => {
      return item.dataset.model === model && optionValue(item, "opt1") === color && optionValue(item, "opt2") === nextSet;
    });
    if (!hasSet) nextSet = firstSetForModelColor(root, model, color);

    root.querySelectorAll(".series-set-title, .series-set-options").forEach((item) => {
      item.classList.toggle("d-none", !showSet);
    });

    root.querySelectorAll(SELECTORS.setItem).forEach((item) => {
      const visible = item.dataset.model === model && optionValue(item, "opt1") === color;
      const selected = visible && optionValue(item, "opt2") === nextSet;
      item.classList.toggle("d-none", !visible);
      item.classList.toggle("selected", selected);
      item.setAttribute("aria-pressed", selected ? "true" : "false");
    });

    setText(root, ".opts-val-2", nextSet);
    root.dataset.set = nextSet;
    return nextSet;
  }

  function selectedRadio(root) {
    return root.querySelector(`${SELECTORS.setItem}.selected`);
  }

  function updateUrl(variantId) {
    if (!variantId || !window.history || !window.URL) return;
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url.href);
  }

  // Notify the Amazon Shopify adapter when Series changes the actual cart form.
  // Writing input.value alone does not fire native input/change events.
  const bwpFormSignatures = new WeakMap();
  function notifyBwpForm(root) {
    const form = root.querySelector('.hidden-form form[data-type="add-to-cart-form"]');
    const idField = form && form.querySelector('input[name="id"], select[name="id"]');
    if (!idField || !idField.value) return;
    const quantity = form.querySelector('input[name="quantity"]')?.value || '1';
    const signature = [idField.value, quantity, document.body.classList.contains('subscription-250901')].join('|');
    if (bwpFormSignatures.get(form) === signature) return;
    bwpFormSignatures.set(form, signature);
    idField.dispatchEvent(new Event('input', { bubbles: true }));
    idField.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Sync Amazon delivery message with selected Shopify Variant.
  function syncAmazonDeliveryMessage(root, variantId) {
    if (!variantId) return;

    const externalId = `gid://shopify/ProductVariant/${variantId}`;

    root.querySelectorAll(
      '.pb-bottom-wrapper .more-info amazon-delivery-message'
    ).forEach((element) => {
      if (element.getAttribute('product-external-id') !== externalId) {
        element.setAttribute('product-external-id', externalId);
      }
    });
  }

  function updateForm(root, variant, radio) {
    if (!variant && radio) {
      variant = { id: radio.dataset.targetVariant, inventory_quantity: parseInt(radio.dataset.inv || "0", 10) };
    }
    if (!variant) return;

    const quantity = getQuantity();
    const variantId = String(variant.id);
    const inventory = Number.isFinite(variant.inventory_quantity) ? variant.inventory_quantity : parseInt(radio && radio.dataset.inv || "0", 10);

    document.querySelectorAll(".brush-with-head input[name='items[0][id]'], .as-cart-variant-fields input[name='id'], .as-go-cart-page input[name='id']").forEach((input) => {
      input.value = variantId;
    });
    document.querySelectorAll(".brush-with-head input[name='items[0][quantity]'], .as-cart-variant-fields input[name='quantity'], .as-go-cart-page input[name='quantity']").forEach((input) => {
      input.value = String(quantity);
    });
    document.querySelectorAll("#as-inventory-quantity").forEach((input) => {
      input.value = String(inventory || 0);
    });

    const checkoutLink = root.querySelector(".hidden-form .as-checkout-btn[data-cart-url]");
    if (checkoutLink) {
      const base = checkoutLink.dataset.cartUrl || "/cart";
      checkoutLink.setAttribute("href", `${base}/${variantId}:${quantity}`);
    }

    const addButton = root.querySelector(".my-add-cart-btn");
    const notifyButton = root.querySelector(".my-inventory-0");
    const available = inventory > 0 || variant.available === true;
    if (addButton) addButton.classList.toggle("super-hidden", !available);
    if (notifyButton) notifyButton.classList.toggle("super-hidden", available);

    const hiddenAdd = root.querySelector(".hidden-form button[name='add']");
    if (hiddenAdd) hiddenAdd.disabled = !available;
    const hiddenNotify = root.querySelector(".hidden-form .as-notify-me-btn");
    if (hiddenNotify) hiddenNotify.classList.toggle("d-none", available);
  }

  function updateBottomPrice(root, radio) {
    if (!radio) return;
    const price = radio.querySelector(".variant_price");
    const compare = radio.querySelector(".variant_comp_price");
    const discount = radio.querySelector(".variant_discount");
    const bottomPrice = root.querySelector(".price-it-1");
    const bottomCompare = root.querySelector(".price-it-2");
    const bottomDiscount = root.querySelector(".price-it-3");
    if (price && bottomPrice) bottomPrice.textContent = price.textContent.trim();

    if (bottomCompare) {
      const wrapper = bottomCompare.closest(".price-full-format-2");
      if (compare && compare.textContent.trim()) {
        bottomCompare.textContent = compare.textContent.trim();
        if (wrapper) wrapper.classList.remove("d-none");
      } else if (wrapper) {
        wrapper.classList.add("d-none");
      }
    }

    if (bottomDiscount) {
      const wrapper = bottomDiscount.closest(".price-full-format-3");
      if (discount && discount.textContent.trim()) {
        bottomDiscount.textContent = discount.textContent.trim();
        if (wrapper) wrapper.classList.remove("d-none");
      } else if (wrapper) {
        wrapper.classList.add("d-none");
      }
    }
  }

  function updateGallery(model, color, set) {
    const gallery = document.querySelector(".as-pb-box-250320");
    if (!gallery) return;
    gallery.dataset.model = model;
    gallery.dataset.color = color || "default";
    gallery.dataset.set = set || "Standard";
    const modelInput = gallery.querySelector("#gallary_model_changer");
    const colorInput = gallery.querySelector("#gallary_color_changer");
    const setInput = gallery.querySelector("#gallary_color_changer_2");
    if (modelInput) modelInput.value = model;
    if (colorInput) colorInput.value = color || "default";
    if (setInput) setInput.value = set || "Standard";
    gallery.dispatchEvent(new CustomEvent("switchGallary", { detail: { model, color, set } }));
  }

  function enforceScopedGalleryState(root) {
    if (!isRemoveUltraTest(root) || typeof MutationObserver === "undefined") return;
    const gallery = document.querySelector(".as-pb-box-250320[data-elevate-page-test='remove-ultra']");
    if (!gallery) return;

    let repairing = false;
    const repair = () => {
      if (repairing) return;
      const state = selectedState(root);
      const model = isAllowedModel(root, state.model) ? state.model : "NEOS II SE";
      const color = state.color || root.dataset.color || firstColorForModel(root, model);
      const set = state.set || root.dataset.set || "Standard";
      const rootMatches = root.dataset.model === model && root.dataset.color === color && root.dataset.set === set;
      const galleryMatches = gallery.dataset.model === model && gallery.dataset.color === color && gallery.dataset.set === set;
      if (rootMatches && galleryMatches) return;

      repairing = true;
      root.dataset.model = model;
      root.dataset.color = color;
      root.dataset.set = set;
      updateGallery(model, color, set);
      repairing = false;
    };

    const observer = new MutationObserver(repair);
    observer.observe(gallery, {
      attributes: true,
      attributeFilter: ["data-model", "data-color", "data-set"]
    });
    observer.observe(root, {
      attributes: true,
      attributeFilter: ["data-model", "data-color", "data-set"]
    });
    window.requestAnimationFrame(repair);
  }

  function announceModel(model) {
    document.dispatchEvent(new CustomEvent("neos-series:model-change", { detail: { model } }));
  }

  function addTimeoutClass(element, className) {
    if (!element || !className || element.classList.contains(className)) return;
    element.classList.add(className);
    window.setTimeout(() => {
      element.classList.remove(className);
    }, 1000);
  }

  function refreshGalleryCartCount() {
    const gallery = document.querySelector(".pb-box-250320");
    if (gallery) gallery.dispatchEvent(new Event("cartChange"));
  }

  function submitAddToCart(root) {
    const add = root.querySelector(".hidden-form button[name='add']");
    if (add) {
      add.click();
      return true;
    }

    const form = root.querySelector(".hidden-form form[action$='/cart/add'], .hidden-form form[data-type='add-to-cart-form']");
    if (!form) return false;
    const temporaryAdd = document.createElement("button");
    temporaryAdd.type = "submit";
    temporaryAdd.name = "add";
    temporaryAdd.hidden = true;
    form.appendChild(temporaryAdd);
    temporaryAdd.click();
    window.setTimeout(() => temporaryAdd.remove(), 0);
    return true;
  }

  function bindCartButton() {
    const cartButton = document.querySelector(".pb-box-250320 .series-pb-tools-1 .pbb-right");
    if (!cartButton) return;
    cartButton.setAttribute("href", "/cart");
    cartButton.setAttribute("data-slidecart-open", "true");
    cartButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
  }

  // Sync holiday promotion with the selected Series set.
  function syncSeriesHolidayNotes(root, set) {
    const panel = root.querySelector(".pb-bottom-wrapper.dock-bottom");
    const left = panel?.querySelector(".left-ticks");
    if (!panel || !left) return;

    const notes = Array.from(panel.querySelectorAll(".price-extra-desc"));
    if (!notes.length) return;

    const currentSet = String(set || "").trim().toLowerCase();
    const onMobile = window.matchMedia("(max-width: 1024px)").matches;
    let hasVisibleNote = false;

    notes.forEach((note) => {
      const allowedSet = String(note.dataset.allowSet || "").trim().toLowerCase();
      const matched = allowedSet === "all" ||
        (allowedSet !== "" && allowedSet === currentSet);

      note.dataset.allowResult = matched ? "yes" : "no";
      note.style.display = matched ? "" : "none";

      const forThisScreen = note.classList.contains(
        onMobile ? "mobile-object" : "pc-object"
      );
      if (matched && forThisScreen) hasVisibleNote = true;
    });

    left.dataset.allowResult = hasVisibleNote ? "yes" : "no";
    const price = left.querySelector(".price-full-format-1");
    if (price) price.dataset.allowResult = hasVisibleNote ? "yes" : "no";

    left.classList.toggle("ltc-holidays", hasVisibleNote);
    left.classList.toggle("ltc-prices", !hasVisibleNote);
    panel.classList.toggle("b-docker-holidays", hasVisibleNote);
    panel.classList.toggle("b-docker-prices", !hasVisibleNote);
  }


  function applyState(root, nextState) {
    const current = selectedState(root);
    let model = nextState.model || current.model;
    if (!isAllowedModel(root, model)) model = "NEOS II SE";
    root.dataset.model = model;
    updateModelCards(root, model);
    const requestedColor = model !== current.model
      ? firstColorForModel(root, model)
      : (nextState.color || current.color);
    const color = updateColorItems(root, model, requestedColor);
const set = updateSetItems(root, model, color, nextState.set || current.set);

// Sync holiday note after selected set is resolved.
syncSeriesHolidayNotes(root, set);

const variant = findVariant(root, model, color, set);
    const radio = selectedRadio(root);
    updateBottomPrice(root, radio);
    updateForm(root, variant, radio);
 
    if (variant) {
      syncAmazonDeliveryMessage(root, variant.id);
      updateUrl(variant.id);
    }

    updateGallery(model, color, set);
    announceModel(model);
    // Subscription fields are moved synchronously by the model-change listener.
    // Notify only after the real one-time-purchase field is in its final form.
    notifyBwpForm(root);
  }

let selectorInitialModel = "";
let selectorHasSwitched = false;

function trackModelSelectorEvent(eventName, params = {}) {
  if (
  document.body.dataset.template !== "product.neos-ii-series" &&
  !isRemoveUltraTest(root)
) return;

  const payload = {
    selector_name: "neos_ii_series",
    page_path: window.location.pathname,
    device_type: compareDeviceType(),
    ...params
  };

  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, payload);
  }

  console.log("[neos-series-model-selector]", eventName, payload);
}

function selectModelFromCard(root, nextModel) {
  const previousModel = selectedState(root).model;

  applyState(root, { model: nextModel, set: "Standard" });

  const currentModel = selectedState(root).model;

  if (previousModel === currentModel) return;

  trackModelSelectorEvent("model_selector_switch", {
    initial_model: selectorInitialModel || previousModel,
    from_model: previousModel,
    to_model: currentModel,
    is_first_switch: String(!selectorHasSwitched)
  });

  selectorHasSwitched = true;
}

function initModelSelectorTracking(root) {
  
if (
  document.body.dataset.template !== "product.neos-ii-series" &&
  !isRemoveUltraTest(root)
) return;


  selectorInitialModel = selectedState(root).model;
  selectorHasSwitched = false;

  const target =
    root.querySelector(".series-model-selector .version-title-row") ||
    root.querySelector(".series-model-selector");

  if (!target) return;

  let viewTracked = false;

  const sendView = () => {
    if (viewTracked) return;
    viewTracked = true;

    trackModelSelectorEvent("model_selector_view", {
      initial_model: selectorInitialModel,
      current_model: selectedState(root).model
    });
  };

  if (typeof IntersectionObserver === "function") {
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        sendView();
        observer.disconnect();
      }
    }, { threshold: 0 });

    observer.observe(target);
  } else {
    const checkVisible = () => {
      const rect = target.getBoundingClientRect();

      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        sendView();
        window.removeEventListener("scroll", checkVisible);
        window.removeEventListener("resize", checkVisible);
      }
    };

    window.addEventListener("scroll", checkVisible, { passive: true });
    window.addEventListener("resize", checkVisible);
    checkVisible();
  }
}

  function bindEvents(root) {
    const dialog = root.querySelector(".series-model-dialog");
    const openDialog = (triggerSource = "unknown") => {
      if (!dialog) return;

      const wasClosed = dialog.classList.contains("d-none");

      dialog.classList.remove("d-none");

      // 只在真正从关闭 -> 打开时触发
      if (!wasClosed) return;

      const compareModels = getCompareModels(dialog);

      trackCompareEvent("model_compare_open", {
        device_type: compareDeviceType(),
        trigger_source: triggerSource,
        current_model: root.dataset.model || "",
        left_model: compareModels.leftModel,
        right_model: compareModels.rightModel
      });
    };
    const closeDialog = () => {
      if (dialog) dialog.classList.add("d-none");
    };

    root
      .querySelectorAll(
        ".series-model-help, .product-controls-mheader .version-description"
      )
      .forEach((trigger) => {
        const triggerSource = trigger.classList.contains("series-model-help")
          ? "model_selector_help"
          : "mobile_header";

        trigger.addEventListener("click", () => {
          openDialog(triggerSource);
        });

        trigger.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            openDialog(triggerSource);
          }
        });
      });

    if (dialog) {
      dialog.addEventListener("click", (event) => {
        if (event.target === dialog || event.target.classList.contains("version-dialog-close") || event.target.classList.contains("vdc-btn")) {
          closeDialog();
        }
      });
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") closeDialog();
      });
    }


root.querySelectorAll(SELECTORS.modelCard).forEach((card) => {
  card.addEventListener("click", () => {
    selectModelFromCard(root, card.dataset.model);
  });

  card.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      selectModelFromCard(root, card.dataset.model);
    }
  });
});


    root.querySelectorAll(SELECTORS.colorItem).forEach((item) => {
      item.addEventListener("click", () => applyState(root, { model: item.dataset.model, color: item.dataset.value, set: "Standard" }));
      item.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          applyState(root, { model: item.dataset.model, color: item.dataset.value, set: "Standard" });
        }
      });
    });

    root.querySelectorAll(SELECTORS.setItem).forEach((item) => {
      item.addEventListener("click", () => applyState(root, { model: item.dataset.model, color: optionValue(item, "opt1"), set: optionValue(item, "opt2") }));
      item.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          applyState(root, { model: item.dataset.model, color: optionValue(item, "opt1"), set: optionValue(item, "opt2") });
        }
      });
    });

    root.querySelectorAll(".quantity-selector-wrapper input[name='quantity']").forEach((input) => {
      input.addEventListener("change", () => applyState(root, {}));
    });

    const buyButton = root.querySelector(".my-add-cart-btn");
    if (buyButton) {
      buyButton.addEventListener("click", () => {
        if (buyButton.classList.contains("super-hidden")) return;
        addTimeoutClass(buyButton, "clicked");
        const type = buyButton.dataset.type;
        const checkoutLink = root.querySelector(".hidden-form .as-checkout-btn[data-cart-url]");
        if (type === "1" && checkoutLink) {
          checkoutLink.click();
          return;
        }
        if (submitAddToCart(root)) {
          window.setTimeout(refreshGalleryCartCount, 1000);
        }
      });
    }

    const notifyButton = root.querySelector(".my-inventory-0");
    if (notifyButton) {
      notifyButton.addEventListener("click", () => {
        const hiddenNotify = root.querySelector(".hidden-form .as-notify-me-btn");
        if (hiddenNotify) hiddenNotify.click();
      });
    }

    // =========================================================
    // MOBILE COMPARE MODEL SWITCH
    // =========================================================

    let choices = {};

    Array.from(
      document.querySelectorAll(".version-dialog-holder-se .model-box")
    ).forEach((model) => {
      const type = model.dataset.model;
      choices[type] = model.innerHTML;
    });

    const changeOption = (selectDom, someText) => {
      const oldIndex = Array.from(selectDom.options).findIndex(
        (opt) => opt.textContent.trim() === someText
      );

      if (oldIndex !== -1) {
        selectDom.selectedIndex = oldIndex;
      }
    };

    const dialogSelectors = document.querySelectorAll(
      ".version-dialog-holder-se .n2s-sel"
    );

    if (dialogSelectors && dialogSelectors.length > 0) {

      const isValidNewValue = (newValue, sel) => {
        for (let i = 0; i < dialogSelectors.length; i++) {

          if (sel !== dialogSelectors[i]) {
            const otherSelect = dialogSelectors[i];

            const otherValue =
              otherSelect.options[otherSelect.selectedIndex].text.trim();

            if (newValue === otherValue) {
              return false;
            }
          }
        }

        return true;
      };


      Array.from(dialogSelectors).forEach((sel) => {

        let oldValue =
          sel.options[sel.selectedIndex].text.trim();


        sel.addEventListener("change", function() {

          const newValue =
            this.options[this.selectedIndex].text.trim();

          const previousValue = oldValue;


          // -----------------------------------------------------
          // 1. Prevent duplicate models in left / right columns
          // -----------------------------------------------------

          if (!isValidNewValue(newValue, this)) {
            changeOption(this, previousValue);
            return;
          }


          // -----------------------------------------------------
          // 2. Protect against missing cached model content
          // -----------------------------------------------------

          if (!choices[newValue]) {
            changeOption(this, previousValue);
            return;
          }


          // -----------------------------------------------------
          // 3. Replace comparison model content
          // -----------------------------------------------------

          const model = sel.parentNode.nextElementSibling;

          model.innerHTML = choices[newValue];
          model.setAttribute("data-model", newValue);


          // Only update oldValue after switch succeeds
          oldValue = newValue;


          // -----------------------------------------------------
          // 4. GA4 — Mobile comparison model switch
          // -----------------------------------------------------

          if (compareDeviceType() === "mobile") {

            let switchPosition = "unknown";

            if (sel.closest(".left-box")) {
              switchPosition = "left";
            } else if (sel.closest(".right-box")) {
              switchPosition = "right";
            }


            const compareModels = getCompareModels(dialog);


            trackCompareEvent("model_compare_switch", {
              device_type: "mobile",

              switch_position: switchPosition,

              from_model: previousValue,
              to_model: newValue,

              left_model: compareModels.leftModel,
              right_model: compareModels.rightModel
            });
          }

        });

      });

    }

  }

  function initSeriesSubscriptions(root) {
    const block = root.querySelector('.series-subscriptions');
    const source = block && block.querySelector('.series-subscription-data');
    if (!source) return;
    let config;
    try { config = JSON.parse(source.textContent); } catch (_) { return; }
    const mapping = Object.fromEntries((config.mapping || '').split(';').filter(Boolean).map(pair => {
      const [color, ids = ''] = pair.split('|');
      return [color.trim(), ids.split(',').map(id => id.trim()).filter(Boolean)];
    }));
    ['Cloud Blue', 'Lilac Pink'].forEach(color => {
      const id = String(config.seIds[color] || '').trim();
      mapping[color] = config.seEnabled && /^\d+$/.test(id) ? [id] : [];
    });
    const list = block.querySelector('.product_subscribe_block_impl');
    const template = list.querySelector('.demo-discr-prod-card-org');
    const form = root.querySelector('.hidden-form form[data-type="add-to-cart-form"]');
    const fields = root.querySelector('.brush-with-head');
    const singleFields = root.querySelector('.as-cart-variant-fields');
    const parking = root.querySelector('.multi-fields-wrapper');
    if (!form || !fields || !singleFields || !parking) return;
    const panel = root.querySelector('.pb-bottom-wrapper');
    const originalNoBwp = panel?.classList.contains('no-bwp');
    const originalBodyNoBwp = document.body.classList.contains('no-bwp');
    let selection = null;
    let stateKey = '';
    let choices = [];
    let selectionInitFlag = false;
    const mask = block.querySelector('.spm-mask');
    const closeDialog = () => mask && mask.classList.add('spm-hidden');
    const maskPolicy = block.querySelector('.spm-mask-policy');
    const closeDialogPolicy = () => maskPolicy && maskPolicy.classList.add('spm-hidden');
    const updateDialogImages = () => {
      block.querySelectorAll('.spm-banner').forEach(img => {
        img.src = window.matchMedia('(max-width: 767px)').matches ? img.dataset.mobile : img.dataset.pc;
      });
    };
    block.addEventListener('click', event => {
      if (event.target.closest('.spm-dialog-getter')) {
        const t = event.target.closest('.spm-dialog-getter');
        event.preventDefault(); event.stopPropagation(); updateDialogImages();
        if(t.classList.contains("spm-dialog-getter-policy")) {
          maskPolicy.classList.remove('spm-hidden');
        } else {
          mask.classList.remove('spm-hidden');
        }
      }
      if (event.target === mask || event.target.closest('.spm-close, .s4-btn')) closeDialog();
      if (event.target === maskPolicy || event.target.closest('.spm-close-policy, .s4-btn-policy')) closeDialogPolicy();
    });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') closeDialog(); });
    const planInputs = id => Array.from(root.querySelectorAll('.shopify_subscriptions_app_container section[data-variant-id]'))
      .find(section => section.dataset.variantId === id)?.querySelectorAll('input[data-selling-plan-id]') || [];
    const getChoices = () => {
      const color = root.dataset.color;
      const isSE = root.dataset.model === 'NEOS II SE';
      if (isSE && !config.seEnabled) return [];
      if (block.dataset.showMe === '1' && !['Standard', 'default', 'Classic Clean'].includes(root.dataset.set)) return [];
      return (mapping[color] || []).flatMap(id => {
        const variant = config.variants.find(item => item.id === id && item.available);
        if (!variant) return [];
        const appPlans = Array.from(planInputs(id));
        return variant.plans.filter(plan => plan.price > 0 && appPlans.some(input => input.dataset.sellingPlanId === plan.id))
          .map(plan => ({ variant, plan, image: (isSE && config.seImage) || variant.image }));
      });
    };
    const syncForm = () => {
      const currentChoices = getChoices();
      if (selection && !currentChoices.some(item => item.variant.id === selection.variant.id && item.plan.id === selection.plan.id)) selection = null;
      const active = Boolean(selection && !block.hidden);
      const quantity = String(getQuantity());
      const host = selectedRadio(root)?.dataset.targetVariant;
      if (host) {
        singleFields.querySelector('input[name="id"]').value = host;
        fields.querySelector('input[name="items[0][id]"]').value = host;
      }
      singleFields.querySelector('input[name="quantity"]').value = quantity;
      fields.querySelector('input[name="items[0][quantity]"]').value = quantity;
      fields.querySelector('input[name="items[1][quantity]"]').value = quantity;
      fields.querySelector('input[name="items[1][id]"]').value = active ? selection.variant.id : '';
      fields.querySelector('input[name="items[1][selling_plan]"]').value = active ? selection.plan.id : '';
      fields.querySelector('input[name="items[0][selling_plan]"]').value = '';
      form.querySelectorAll('input[name="selling_plan"], input[name="spidBackup"]').forEach(input => { input.value = ''; });
      parking.appendChild(active ? singleFields : fields);
      form.appendChild(active ? fields : singleFields);
      document.body.classList.toggle('subscription-250901', active);
      if (panel?.dataset.shb === 'true') {
        panel.classList.toggle('no-bwp', active || originalNoBwp);
        document.body.classList.toggle('no-bwp', active || originalBodyNoBwp);
      }
      root.querySelectorAll('.sales-point-wrapper .ssp-text').forEach(text => {
        if (text.textContent.includes('24-Month Warranty')) text.closest('.who-align-left, .who-align-right')?.classList.toggle('d-none', active);
      });
      const description = root.querySelector('.other-descriptions');
      if (description) {
        description.classList.toggle('d-none', !active);
        description.textContent = active ? selection.plan.name : '';
      }
      list.querySelectorAll('.demo-discr-prod-card').forEach(card => {
        const selected = active ? card.dataset.variant === selection.variant.id && card.dataset.sellingPlanId === selection.plan.id : card.classList.contains('demo-discr-prod-card-onetime');
        card.classList.toggle('selected', selected);
        card.setAttribute('aria-checked', String(selected));
      });
      // Restore Amazon's awareness after one-time/subscription form swaps.
      notifyBwpForm(root);
      block.dispatchEvent(new Event('switchSubscription'));
    };
    const bindCard = (card, choice) => {
      card.setAttribute('role', 'radio'); card.tabIndex = 0;
      const choose = () => { selection = choice; syncForm(); };
      card.addEventListener('click', event => { if (!event.target.closest('.spm-dialog-getter')) choose(); });
      card.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(); }
      });
    };
    const render = () => {
      list.querySelectorAll('.demo-discr-prod-card').forEach(card => card.remove());
      block.hidden = choices.length === 0;
      if (block.hidden) { closeDialog(); syncForm(); return; }
      list.setAttribute('role', 'radiogroup');
      list.setAttribute('aria-label', block.querySelector('.psb-title')?.textContent || 'Subscription options');
      const oneTime = document.createElement('div');
      oneTime.className = 'demo-discr-prod-card-org p-3 demo-discr-prod-card demo-discr-prod-card-onetime';
      const inner = document.createElement('div'); inner.className = 'internal-box';
      inner.appendChild(template.querySelector('.choice-area').cloneNode(true));
      const title = document.createElement('div'); title.className = 'content-area discr-prod-name pc-c-16 mo-c-16'; title.textContent = block.dataset.nosubscription;
      inner.appendChild(title); oneTime.appendChild(inner); bindCard(oneTime, null);
      if (block.querySelector('.onetime-at-top')?.value === '1') list.appendChild(oneTime);
      choices.forEach(choice => {
        const { variant, plan } = choice;
        const card = template.cloneNode(true); card.classList.add('demo-discr-prod-card');
        card.dataset.variant = variant.id; card.dataset.sellingPlanId = plan.id; card.dataset.color = root.dataset.color;
        if (choice.image) {
          const img = document.createElement('img'); img.src = choice.image; img.alt = variant.title; img.width = 100; img.height = 100;
          card.querySelector('.icon-wrapper').appendChild(img);
        }
        const configured = (window.ultra_subscriptions_20251009 || []).find(item => String(item.variantId) === variant.id);
        const name = card.querySelector('.discr-prod-name');
        if (configured?.variantTitle) name.innerHTML = configured.variantTitle;
        else name.textContent = `${variant.type || variant.title} Brush Head Subscription`;
        const description = card.querySelector('.discr-prod-plan');
        if (configured?.variantDescription) description.innerHTML = configured.variantDescription;
        else description.textContent = variant.title;
        card.querySelector('.now-price').innerHTML = plan.priceText;
        card.querySelector('.org-price').innerHTML = plan.comparePrice > plan.price ? plan.compareText : '';
        const tag = card.querySelector('.at-special-tag');
        if (plan.comparePrice > plan.price) { tag.textContent = `${Math.round(100 * (1 - plan.price / plan.comparePrice))}% OFF`; tag.classList.remove('d-none'); }
        bindCard(card, choice); list.appendChild(card);
      });
      if(!selection && block.querySelector('.onetime-as-default')?.value === '1' && choices[0]) selection = choices[0]; 
      if (!oneTime.parentElement) list.appendChild(oneTime);
      syncForm();
    };
    const refresh = () => {
      const nextKey = [root.dataset.model, root.dataset.color, root.dataset.set].join('|');
      const nextChoices = getChoices();
      const changed = nextKey !== stateKey;
      const changedChoices = nextChoices.map(item => item.variant.id + ':' + item.plan.id).join(',') !== choices.map(item => item.variant.id + ':' + item.plan.id).join(',');
      if (changed || changedChoices) {
        selection = null; closeDialog(); stateKey = nextKey; choices = nextChoices; render();
      } else syncForm();
    };
    document.addEventListener('neos-series:model-change', refresh);
    document.querySelector('.as-pb-box-250320')?.addEventListener('switchGallary', refresh);
    root.querySelector('.quantity-selector-wrapper')?.addEventListener('input', syncForm);
    form.addEventListener('submit', event => {
      syncForm();
      if (!selection || block.hidden) return;
      const productForm = form.closest('product-form');
      if (typeof productForm?.add2cart !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = form.querySelector('button[name="add"]');
      if (button?.classList.contains('loading')) return;
      productForm.$addToCart = button;
      productForm.$errorMessageWrapper = productForm.querySelector('.as-product-form__error-message-wrapper');
      productForm.$errorMessage = productForm.querySelector('.as-product-form__error-message');
      productForm.add2cart([
        { id: fields.querySelector('input[name="items[0][id]"]').value, quantity: getQuantity() },
        { id: selection.variant.id, quantity: getQuantity(), selling_plan: selection.plan.id }
      ]);
    }, true);
    const observer = new MutationObserver(refresh);
    root.querySelectorAll('.shopify-app-block[id*="subscriptions_app_block"]').forEach(app => observer.observe(app, { childList: true, subtree: true }));
    refresh();
  }

  function initSeriesBwp(root) {
    const panel = root.querySelector('.pb-bottom-wrapper');
    const mount = panel?.querySelector('.series-bwp-mount');
    if (!panel || !mount || panel.dataset.showBwp !== 'true') return;

    // A visual placeholder never counts as Amazon checkout availability.
    panel.classList.add('series-bwp-unavailable');
    const update = () => {
      const host = mount.querySelector('delivery-promise-wc');
      const button = host?.shadowRoot?.querySelector('button');
      const eligible = Boolean(button && !host.classList.contains('d-none'));
      panel.classList.toggle('series-bwp-unavailable', !eligible);
      // Diagnostic only: Amazon's own button remains the clickable target.
      panel.dataset.seriesBwpReady = String(eligible);
    };

    let shadowObserver;
    const observeHost = () => {
      const host = mount.querySelector('delivery-promise-wc');
      if (!host || !host.shadowRoot || host === observeHost.currentHost) return;
      shadowObserver?.disconnect();
      observeHost.currentHost = host;
      shadowObserver = new MutationObserver(update);
      shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });
    };
    const observer = new MutationObserver(() => { observeHost(); update(); });
    observer.observe(mount, { childList: true, subtree: true });
    observeHost();
    update();
    // The adapter may complete its first render without further light-DOM mutation.
    window.addEventListener('load', update, { once: true });
  }

function init() {
  const root = getRoot();
  if (!root) return;

  bindEvents(root);
  bindCartButton();
  initSeriesSubscriptions(root);
  initSeriesBwp(root);

  const pathname = window.location.pathname.replace(/\/$/, "");
  const isSePurchasePage = pathname.endsWith("/products/soocas-neos-ii-se");

  const url = new URL(window.location.href);
  const hasExplicitVariant = url.searchParams.has("variant");

  if (isSePurchasePage && !hasExplicitVariant) {
    const defaultModel = "NEOS II SE";
    const defaultColor = firstColorForModel(root, defaultModel);

    applyState(root, {
      model: defaultModel,
      color: defaultColor,
      set: "Standard"
    });
  } else {
    applyState(root, selectedState(root));
  }
  enforceScopedGalleryState(root);
initModelSelectorTracking(root);
  root.querySelectorAll(".pb-bottom-loader").forEach((item) => {
    item.classList.remove("super-hidden-1");
  });
}

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
